import { CircularProgress } from '@mui/material';
import { useEditGoal } from '_api';
import { Goal, GoalPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { AlertMessage, BaseModal } from 'components/molecules';
import { GoalForm } from 'components/organisms/forms';
import React, { useEffect, useState } from 'react';

import { GoalModalProps } from './types';

export const EditGoalModal = ({
  hasLongTermGoal,
  initValue,
  open,
  onClose,
  patientId,
}: GoalModalProps) => {
  const { mutateAsync: editGoal } = useEditGoal();

  const convertToGoalPayload = (initGoal: Goal) => {
    const { goalNotes: _goalNotes, ...data } = initGoal;
    return {
      ...data,
      goalType: data.goalType.name,
      status: data.status.name,
      patientId: patientId,
    };
  };

  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [goal, setGoal] = useState(
    initValue ? convertToGoalPayload(initValue) : undefined,
  );

  useEffect(() => {
    if (initValue) setGoal(convertToGoalPayload(initValue));
  }, [initValue]);

  const close = () => {
    setGoal(undefined);
    onClose();
  };

  const onSubmit = (submitGoal: GoalPayload) => {
    if (submitGoal.title.trim().length === 0) {
      setErrorMessage('Goal Title must be provided.');
      setShowError(true);
    } else {
      editGoal(submitGoal)
        .then((data) => {
          if (data && data.id) {
            setShowSuccess(true);
            setTimeout(() => {
              close();
            }, 1500);
          }
        })
        .catch(() => setShowError(true));
    }
  };

  return (
    <BaseModal open={open} onClose={close} title={'Edit Goal'}>
      {goal ? (
        <GoalForm
          hasLongTermGoal={hasLongTermGoal}
          initValue={goal}
          onBack={close}
          onSubmit={onSubmit}
        />
      ) : (
        <CircularProgress />
      )}
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Goal successfully updated.'}
      />
      <AlertMessage
        open={showError}
        onClose={() => setShowError(false)}
        severity={SEVERITY.error}
        message={
          <>
            Failed to edit Goal.
            <br />
            {errorMessage}
            <br />
            Resolve form issues and try again.
          </>
        }
      />
    </BaseModal>
  );
};
